import Mock from './Mock';

export default class InformationPageServiceMock {
  static getPageByName(name) {
    let data = {};
    if (name === 'EMPLOYMENT_INSURANCE') {
      data = {
        name: 'EMPLOYMENT_INSURANCE',
        sectionName: 'PAGES_SECTION_JOB',
        title: 'Apply for Employment Insurance',
        language: 'en',
        contents: [
          {
            text: 'Telephone Reporting',
            phoneNumber: '1-800-531-7555.',
            contentType: 'Phone',
            order: 3,
          },
          {
            text: 'Online Reporting',
            link:
              'https://www.canada.ca/en/services/benefits/ei/ei-internet-reporting.html',
            contentType: 'Link',
            order: 2,
          },
          {
            text:
              'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce eleifend massa ac nulla tristique, eget maximus felis sagittis. Sed et dolor a augue dictum vehicula. Aliquam gravida facilisis justo. Maecenas maximus convallis dui a semper. Morbi sit amet tortor pretium, placerat mauris id, laoreet nulla. Curabitur mattis felis erat, et faucibus ligula tristique et. Nulla sed egestas libero, ut rhoncus odio. Vivamus molestie suscipit accumsan. Maecenas sit amet arcu quis nibh luctus malesuada. Donec nisl neque, ultrices eu lacinia lobortis, euismod dapibus sem. Donec eleifend magna feugiat enim auctor, ut pretium neque tincidunt. Donec ultrices facilisis nulla vitae pulvinar. Aliquam sodales efficitur mattis. Proin auctor fringilla facilisis. Integer a urna viverra, malesuada turpis et, efficitur lacus. Donec a tortor a massa rhoncus semper.',
            contentType: 'Text',
            order: 1,
          },
        ],
      };
    } else if (name === 'FIND_JOB') {
      data = {
        name: 'FIND_JOB',
        sectionName: 'PAGES_SECTION_JOB',
        title: 'Find a job',
        language: 'en',
        contents: [
          {
            text: 'Fill the form - CCQ',
            link: 'http://carnet.ccq.org/en/workers/',
            contentType: 'Link',
            order: 3,
          },
          {
            text: 'Fill the form - SQC',
            link: 'http://www.sqc.ca/membre/trouver-un-emploi/',
            contentType: 'Link',
            order: 2,
          },
          {
            text:
              'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce eleifend massa ac nulla tristique, eget maximus felis sagittis. Sed et dolor a augue dictum vehicula. Aliquam gravida facilisis justo. Maecenas maximus convallis dui a semper. Morbi sit amet tortor pretium, placerat mauris id, laoreet nulla. Curabitur mattis felis erat, et faucibus ligula tristique et. Nulla sed egestas libero, ut rhoncus odio. Vivamus molestie suscipit accumsan. Maecenas sit amet arcu quis nibh luctus malesuada. Donec nisl neque, ultrices eu lacinia lobortis, euismod dapibus sem. Donec eleifend magna feugiat enim auctor, ut pretium neque tincidunt. Donec ultrices facilisis nulla vitae pulvinar. Aliquam sodales efficitur mattis. Proin auctor fringilla facilisis. Integer a urna viverra, malesuada turpis et, efficitur lacus. Donec a tortor a massa rhoncus semper.',
            contentType: 'Text',
            order: 1,
          },
        ],
      };
    } else if (name === 'WAGE_COMPLAINT') {
      data = {
        name: 'WAGE_COMPLAINT',
        sectionName: 'PAGES_SECTION_JOB',
        title: 'Complaint related to wages',
        language: 'en',
        contents: [
          {
            text: 'Link',
            link: 'about:blank',
            contentType: 'Link',
            order: 2,
          },
          {
            text:
              'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce eleifend massa ac nulla tristique, eget maximus felis sagittis. Sed et dolor a augue dictum vehicula. Aliquam gravida facilisis justo. Maecenas maximus convallis dui a semper. Morbi sit amet tortor pretium, placerat mauris id, laoreet nulla. Curabitur mattis felis erat, et faucibus ligula tristique et. Nulla sed egestas libero, ut rhoncus odio. Vivamus molestie suscipit accumsan. Maecenas sit amet arcu quis nibh luctus malesuada. Donec nisl neque, ultrices eu lacinia lobortis, euismod dapibus sem. Donec eleifend magna feugiat enim auctor, ut pretium neque tincidunt. Donec ultrices facilisis nulla vitae pulvinar. Aliquam sodales efficitur mattis. Proin auctor fringilla facilisis. Integer a urna viverra, malesuada turpis et, efficitur lacus. Donec a tortor a massa rhoncus semper.',
            contentType: 'Text',
            order: 1,
          },
        ],
      };
    } else if (name === 'SALARIES_AND_BENEFITS') {
      data = {
        name: 'SALARIES_AND_BENEFITS',
        sectionName: 'PAGES_SECTION_JOB',
        title: 'Salaries and benefits',
        language: 'en',
        contents: [
          {
            html: '<b>Octobre 31 2018<b/>',
            contentType: 'Html',
            order: 3,
          },
          {
            text:
              'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce eleifend massa ac nulla tristique, eget maximus felis sagittis. Sed et dolor a augue dictum vehicula. Aliquam gravida facilisis justo. Maecenas maximus convallis dui a semper. Morbi sit amet tortor pretium, placerat mauris id, laoreet nulla. Curabitur mattis felis erat, et faucibus ligula tristique et. Nulla sed egestas libero, ut rhoncus odio. Vivamus molestie suscipit accumsan. Maecenas sit amet arcu quis nibh luctus malesuada. Donec nisl neque, ultrices eu lacinia lobortis, euismod dapibus sem. Donec eleifend magna feugiat enim auctor, ut pretium neque tincidunt. Donec ultrices facilisis nulla vitae pulvinar. Aliquam sodales efficitur mattis. Proin auctor fringilla facilisis. Integer a urna viverra, malesuada turpis et, efficitur lacus. Donec a tortor a massa rhoncus semper.',
            contentType: 'Text',
            order: 2,
          },
          {
            html: '<b>January 1st 2018<b/>',
            contentType: 'Html',
            order: 1,
          },
          {
            text:
              'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce eleifend massa ac nulla tristique, eget maximus felis sagittis. Sed et dolor a augue dictum vehicula. Aliquam gravida facilisis justo. Maecenas maximus convallis dui a semper. Morbi sit amet tortor pretium, placerat mauris id, laoreet nulla. Curabitur mattis felis erat, et faucibus ligula tristique et. Nulla sed egestas libero, ut rhoncus odio. Vivamus molestie suscipit accumsan. Maecenas sit amet arcu quis nibh luctus malesuada. Donec nisl neque, ultrices eu lacinia lobortis, euismod dapibus sem. Donec eleifend magna feugiat enim auctor, ut pretium neque tincidunt. Donec ultrices facilisis nulla vitae pulvinar. Aliquam sodales efficitur mattis. Proin auctor fringilla facilisis. Integer a urna viverra, malesuada turpis et, efficitur lacus. Donec a tortor a massa rhoncus semper.',
            contentType: 'Text',
            order: 4,
          },
          {
            text: 'Official documents',
            link: 'http://www.sqc.ca/centre-de-documentation/',
            contentType: 'Link',
            order: 5,
          },
        ],
      };
    }
    return Mock.call(data);
  }
}
